import { configureStore } from '@reduxjs/toolkit'

import articleSubstitutionsReducer from './articleSubstitutions/articleSubstitutionsSlice'
import bundleReducer from './bundle/bundleSlice'
import configResultReducer from './configResult/configResultSlice'
import customerReducer from './customer/customerSlice'
import initReducer from './init/initSlice'
import internalSaveEventReducer from './internalSaveEvent/internalSaveEventSlice'
import itemsReducer from './items/itemsSlice'
import modelReducer from './model/modelSlice'
import requestsReducer from './requests/requestsSlice'
import selectedItemReducer from './selectedItem/selectedItemSlice'
import uiReducer from './ui/uiSlice'
import yassReducer from './yass/yassSlice'

const reduxDevToolsParam = new URLSearchParams(window.location.search).get('reduxDevTools')
const enableDevTools =
  import.meta.env.VITE_SCENSUM_ENV !== 'production' || reduxDevToolsParam === 'true' || reduxDevToolsParam === 'on'

const store = configureStore({
  devTools: enableDevTools,
  reducer: {
    articleSubstitutions: articleSubstitutionsReducer,
    bundle: bundleReducer,
    configResult: configResultReducer,
    customer: customerReducer,
    init: initReducer,
    internalSaveEvent: internalSaveEventReducer,
    items: itemsReducer,
    model: modelReducer,
    requests: requestsReducer,
    selectedItem: selectedItemReducer,
    ui: uiReducer,
    yass: yassReducer,
  },
})

export type AppStore = typeof store
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']

export default store
